import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { ACCOUNT_TYPE_AGENT } from 'constants/index';
import { EOrganizedBy, ETripEvent, IApiFlightTripEvent, ITripEvent } from 'detailsv2/structure';
import { PERMISSION_GUEST_PORTAL, useIsSubscriptionAllowed } from 'hooks/useIsSubscriptionAllowed';
import { itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';

import s from '../index.module.css';
import DatePicker from './DatePicker';

type Props = {
  tripEvent: IApiFlightTripEvent;
  clearSearchResults: () => void;
};

export const FlightDatePicker = ({ tripEvent, clearSearchResults }: Props) => {
  const { control } = useFormContext();
  const scheduleType = useSelector(itineraryScheduleTypeSelector);
  const isOrganizedByDay = scheduleType === EOrganizedBy.Day;
  const isTier2Subscription = useIsSubscriptionAllowed(ACCOUNT_TYPE_AGENT, PERMISSION_GUEST_PORTAL);

  return (
    <Controller<Partial<ITripEvent<ETripEvent.Flight>>, 'data.flightDate'>
      control={control}
      defaultValue={tripEvent.datesRange.start || ''}
      name="data.flightDate"
      render={({ field, ...rest }) => {
        const onChange = (val?: string | null) => {
          if (!val) return;
          field.onChange(val);
          clearSearchResults();
        };

        return (
          <div className={s.searchTitleWrapper}>
            <div className={s.searchTitle}>Searching for Flights on</div>
            <div>
              <DatePicker
                placeholder="Flight Date"
                mode="single"
                disabled={!isTier2Subscription || isOrganizedByDay}
                field={{ ...field, onChange }}
                closeOnSelect
                {...rest}
              />
            </div>
          </div>
        );
      }}
    />
  );
};
